(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, ajaxPostLoad, jQuery, bodyScrollLock, gsap, Quad */
	let lazyLoadInstance;
	const panelTransitionTime = 1500;
	const imgTransition = 0.4;
	const mdBreakpoint = 738;





// Generate Page Title
// -----------------------------------------------------------------------------

	function generatePageTitle(page) {
		const pageTitle = $("<textarea />").html(page).text();
		return `Pádraic E. Moore | ${pageTitle}`;
	}





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".lazy",
		});
	}





// Init Fancybox
// -----------------------------------------------------------------------------

	function initFancybox() {
		$("[data-fancybox]").fancybox({
			idleTime: false,
			buttons: [
				"close",
			],
			animationEffect: "fade",
			wheel: false,
			mobile: {
				clickContent: function () {
					return false;
				},
				clickSlide: function (current) {
					return current.type === "image" ? false : "close";
				},
			},
			caption: function (instance, item) {
				let caption;
				if (item.type === "image") {
					caption = $(this).parent().find(".img-caption").html();
				}
				return caption;
			},
			beforeShow: function (instance, item) {
				if (item.opts.$orig.parent().find(".img-caption").children().length > 0) {
					$(".js-fancybox-caption-toggle").addClass("is-visible");
				} else {
					$(".js-fancybox-caption-toggle").removeClass("is-visible");
				}
			},
			baseTpl:
				"<div class='fancybox-container' role='dialog' tabindex='-1'>"
				+ "<div class='fancybox-bg'></div>"
				+ "<div class='fancybox-inner'>"
				+ "<div class='fancybox-infobar'><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>"
				+ "<div class='fancybox-toolbar'>{{buttons}}</div>"
				+ "<div class='fancybox-navigation'>{{arrows}}</div>"
				+ "<div class='fancybox-stage'></div>"
				+ "<div class='fancybox-caption'><div class='fancybox-caption__body'></div></div>"
				+ "<div class='fancybox-caption-toggle js-fancybox-caption-toggle'><p><a href='#' class='button button--rounded js-toggle-caption'>Show details</a></p></div>"
				+ "</div>"
				+ "</div>",
			btnTpl: {
				close:
					"<button data-fancybox-close class='fancybox-button fancybox-button--close' title='{{CLOSE}}'>&times;</button>",

				arrowLeft:
					"<button data-fancybox-prev class='fancybox-button fancybox-button--arrow_left' title='{{PREV}}'>&larr;</button>",

				arrowRight:
					"<button data-fancybox-next class='fancybox-button fancybox-button--arrow_right' title='{{NEXT}}'>&rarr;</button>",
			},
		});

		$(document).on("click", ".js-toggle-caption", function (event) {
			event.preventDefault();
			$(".fancybox-caption").toggleClass("is-visible");
			if ($(".fancybox-caption").hasClass("is-visible")) {
				$(this).text("Hide details");
			} else {
				$(this).text("Show details");
			}
		});
	}





// Compensate for Single Container Scrollbar
// -----------------------------------------------------------------------------

	function compensateSingleScrollbar() {
		const panelScrollbar = $(".js-single-container").outerWidth() - $(".js-single-content").outerWidth();
		if (panelScrollbar > 0) {
			$(".js-close-panel-wrapper").css("margin-right", `${panelScrollbar}px`);
		} else {
			$(".js-close-panel-wrapper").css("margin-right", 0);
		}
	}


// Compensate for Scrollbar Activate / Deactivate
// -----------------------------------------------------------------------------

	function lockBody() {
		const targetElement = $(".js-single-inside").get(0);
		bodyScrollLock.disableBodyScroll(targetElement);
	}

	function unlockBody() {
		bodyScrollLock.clearAllBodyScrollLocks();
	}

	function compensateScrollbar() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		if (scrollbarWidth > 0) {
			$(document.head).append(`<style id="pem-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:${scrollbarWidth}px;}</style>`);
		}
	}

	function decompensateScrollbar() {
		$("#pem-style-noscroll").remove();
	}

	function compensateOnSingleLoad() {
		if ($("html").hasClass("panel-is-open")) {
			const panelScrollbar = $(".js-single-container").outerWidth() - $(".js-single-content").outerWidth();
			if (panelScrollbar > 0) {
				$(document.head).append(`<style id="pem-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:${panelScrollbar}px;}</style>`);
			}
			lockBody();
		}
	}


// Open / Close Panel Functions
// -----------------------------------------------------------------------------

	function closePanel() {
		$("html").removeClass("panel-is-open");
		setTimeout(() => {
			$("html").removeClass("overflow-is-hidden");
			decompensateScrollbar();
			unlockBody();
		}, panelTransitionTime);
	}

	function closePanelPushState() {
		closePanel();
		window.history.pushState("Work", generatePageTitle("Work"), "/");
		document.title = generatePageTitle("Work");
	}

	function openPanel() {
		// Compensate for scrollbar
		compensateScrollbar();

		// Open Panel
		$(".js-single-inside").animate({ scrollTop: (0) }, 0);
		$("html").addClass("panel-is-open overflow-is-hidden");
		$(".js-single-loader").removeClass("is-loading");

		// Lock Body
		lockBody();

		// Init Fancybox
		initFancybox();
	}

	function popStateListener(event) {
		if (event.state === "Work") {
			closePanel();
		} else if ((event.state == $(".js-single-container").attr("data-post")) && !$("html").hasClass("panel-is-open")) {
			openPanel();
		}
	}


// Close Single Panel on Click
// -----------------------------------------------------------------------------

	function closePanelOnClick() {
		$(".js-close-panel, .js-single-overlay").click((event) => {
			event.preventDefault();
			closePanelPushState();
		});
	}




// AJAX Single Page
// -----------------------------------------------------------------------------

	function ajaxSinglePage() {
		$(".js-single-link").click(function (event) {
			event.preventDefault();
			const postID = $(this).attr("data-link");
			const postLink = $(this).attr("href");
			$.ajax({
				url: ajaxPostLoad.ajaxurl,
				type: "post",
				data: {
					action: "ajax_post_load",
					post_id: postID,
				},
				beforeSend: () => {
					$(".js-single-loader").addClass("is-loading");
				},
				success: (result) => {
					// Parse content and add to wrapper
					const parsedResult = JSON.parse(result);
					$(".js-single-content").html(parsedResult.result);
					lazyLoadInstance.update();
					$(".js-single-container").attr("data-post", postID);

					// Add margin if scrollbar in wrapper
					compensateSingleScrollbar();

					// Open panel and change url
					openPanel();
					const newPageTitle = generatePageTitle(parsedResult.pageTitle);
					window.history.pushState(postID, newPageTitle, parsedResult.url);
					document.title = newPageTitle;

					// On Escape
					$(document).keyup((e) => {
						if (e.key === "Escape") {
							closePanelPushState();
						}
					});

					// On previous or next - doesn't work when viewing multiple projects
					window.removeEventListener("popstate", popStateListener);
					window.addEventListener("popstate", popStateListener);

				},
				error: () => {
					window.location.href = postLink;
				},
			});
		});
	}





// Sticky Toolbar
// -----------------------------------------------------------------------------

	function stickyFilterToggle(toolbarTop, toolbarHeight) {
		if ($(window).scrollTop() > (toolbarTop + toolbarHeight)) {
			$(".js-archive-filters-toggle-wrapper").addClass("is-visible");
		} else {
			$(".js-archive-filters-toggle-wrapper").removeClass("is-visible");
		}
	}

	function stickyToolbar() {
		if ($(".js-archive-toolbar").length) {
			const toolbarTop = $(".js-archive-toolbar").offset().top;
			const toolbarHeight = $(".js-archive-toolbar").outerHeight();
			$(window).scroll(() => {
				if ($(window).scrollTop() > toolbarTop) {
					$(".js-archive-toolbar").addClass("is-sticky compensate-for-scrollbar");
				} else {
					$(".js-archive-toolbar").removeClass("is-sticky compensate-for-scrollbar");
				}
				stickyFilterToggle(toolbarTop, toolbarHeight);
			});
		}
	}





// Toggle Mobile Toolbar
// -----------------------------------------------------------------------------

	function removeMobileToolbar() {
		decompensateScrollbar();
		$("html").removeClass("overlay-filters-is-visible");
		const toolbarTop = $(".js-archive-toolbar").offset().top;
		const toolbarHeight = $(".js-archive-toolbar").outerHeight();
		stickyFilterToggle(toolbarTop, toolbarHeight);
	}

	function toggleMobileToolbarOnClick() {
		$(".js-archive-filters-toggle, .js-overlay-toolbar-background").click((event) => {
			event.preventDefault();
			if ($("html").hasClass("overlay-filters-is-visible")) {
				removeMobileToolbar();
			} else {
				compensateScrollbar();
				$("html").addClass("overlay-filters-is-visible");
			}
		});
	}





// Search on Click
// -----------------------------------------------------------------------------

	function closeSearch() {
		$("html").removeClass("search-is-open");
		$(".js-search-form").unbind("keyup");
		$(".js-search-form").unbind("blur");
		$(".js-search-form").blur();
		removeMobileToolbar();
		$(".js-search-toggle").off("click");
		searchOnClick();
	}

	function searchKeyUp(e) {
		if (e.key === "Enter" || e.keyCode === 13 || e.key === "Escape" || e.keyCode === 27) {
			closeSearch();
		}
	}

	function closeSearchOnClick() {
		$(".js-search-toggle").on("click", function (event) {
			event.preventDefault();
			closeSearch();
		}).on("mousedown", function (event) {
			event.preventDefault();
		});
	}

	function searchOnClick() {
		$(".js-search-toggle").on("click", function (event) {
			event.preventDefault();
			$("html").addClass("search-is-open");
			const $this = $(this).parent().find(".js-search-form");
			$(".js-search-toggle").off("click");
			closeSearchOnClick();
			$this.focus();
			$this.on("keyup", searchKeyUp);
			$this.bind("blur", () => {
				closeSearch();
			});
		});
	}





// Filter Function
// -----------------------------------------------------------------------------

	function filterArchive() {
		// Category
		const filterCategory = $(".js-archive-filter.is-active").data("filter");
		if (filterCategory === "*") {
			$(".js-archive-list-item").addClass("is-current-category");
		} else {
			$(".js-archive-list-item").removeClass("is-current-category");
			$(`[data-category="${filterCategory}"]`).addClass("is-current-category");
		}

		// Search

		const searchValue = $(".js-search-form").first().val().toLowerCase();
		$(".js-archive-list-item").removeClass("is-current-search");
		$(".js-search-content").each(function () {
			const textValue = $(this).text().toLowerCase();
			if (textValue.includes(searchValue)) {
				$(this).parents(".js-archive-list-item").addClass("is-current-search");
			}
		});

		// Years
		const yearValue = $(".js-years-filter").get(0).value;
		if (yearValue === "*") {
			$(".js-archive-list-item").addClass("is-current-year");
		} else {
			$(".js-archive-list-item").removeClass("is-current-year");
			$(`[data-year="${yearValue}"]`).addClass("is-current-year");
		}

		if ($(".js-archive-list-item.is-current-search.is-current-category.is-current-year").length) {
			$(".js-archive-list-item, .js-no-result").hide();
			$(".js-archive-list-item.is-current-search.is-current-category.is-current-year").show();
		} else {
			if (filterCategory !== "*") {
				$(".js-no-result-category span").html($(`[data-filter="${filterCategory}"]`).first().text());
				$(".js-no-result-category").show();
			} else {
				$(".js-no-result-category").hide();
			}
			if (yearValue !== "*") {
				$(".js-no-result-year span").html(yearValue);
				$(".js-no-result-year").show();
			} else {
				$(".js-no-result-year").hide();
			}
			if (searchValue) {
				$(".js-no-result-search span").html($(".js-search-form").first().val());
				$(".js-no-result-search").show();
			} else {
				$(".js-no-result-search").hide();
			}
			$(".js-archive-list-item").hide();
			$(".js-no-result").show();
		}
		if (!$(window).scrollTop()) {
			lazyLoadInstance.update();
		} else {
			$("html, body").animate({ scrollTop: 0 }, 500, "swing", () => {
				lazyLoadInstance.update();
			});
		}
	}



// Filter by Category
// -----------------------------------------------------------------------------

	function filterByCategory() {
		$(".js-archive-filter").click(function (event) {
			event.preventDefault();
			$(".js-archive-filter").removeClass("is-active");
			const thisCategory = $(this).data("filter");
			$(`.js-archive-filter[data-filter="${thisCategory}"]`).addClass("is-active");
			filterArchive();
			removeMobileToolbar();
		});
	}





// Filter by Search
// -----------------------------------------------------------------------------

	function filterBySearch() {
		$(".js-search-form").on("input", function () {
			const thisInput = $(this).val();
			$(".js-search-form").not(this).val(thisInput);
			if (thisInput) {
				$(".js-search-toggle").addClass("is-active");
			} else {
				$(".js-search-toggle").removeClass("is-active");
			}
			filterArchive();
		});
	}





// Filter by Year
// -----------------------------------------------------------------------------

	function filterByYear() {
		$(".js-years-filter").on("change", function () {
			const yearValue = this.value;
			$(".js-years-filter").val(yearValue);
			$("select").selectric("refresh");
			if (yearValue !== "*") {
				$(".selectric-js-years-filter .selectric").addClass("is-active");
			} else {
				$(".selectric-js-years-filter .selectric").removeClass("is-active");
			}
			filterArchive();
			removeMobileToolbar();
		});
	}





// Reset Filters
// -----------------------------------------------------------------------------

	function resetFilters() {
		$(".js-reset-filters").click((event) => {
			event.preventDefault();
			$(".js-archive-filter").removeClass("is-active");
			$(".js-archive-filter[data-filter='*']").addClass("is-active");
			$(".js-years-filter").val("*");
			$("select").selectric("refresh");
			$(".selectric-js-years-filter .selectric").removeClass("is-active");
			$(".js-search-form").val("");
			$(".js-search-toggle").removeClass("is-active");
			filterArchive();
		});
	}


// List Item Hover
// -----------------------------------------------------------------------------

	function listItemHover() {
		$(".js-single-link").each(function () {
			const thisImg = $(this).parent().find("img");
			if (window.matchMedia(`(min-width: ${mdBreakpoint}px)`).matches === true) {
				$(this).on("mouseenter", () => {
					const thisImgTranslate = ((thisImg.outerWidth() * 2.5) / 2) + 30;
					const tl = gsap.timeline({ paused: true });
					tl.to(thisImg, {
						css: { rotation: 5 }, duration: (imgTransition / 2), ease: Quad.easeIn,
					}, 0);
					tl.to(thisImg, {
						css: { rotation: 0 }, duration: ((imgTransition / 4) * 3), ease: Quad.easeOut,
					}, (imgTransition / 2));
					tl.to(thisImg, {
						css: { scale: 2.5, translateX: -thisImgTranslate }, duration: imgTransition, ease: Quad.easeInOut,
					}, 0);
					tl.play();
				}).on("mouseleave", () => {
					const tl = gsap.timeline({ paused: true });
					tl.to(thisImg, {
						css: { rotation: 5 }, duration: (imgTransition / 2), ease: Quad.easeIn,
					}, 0);
					tl.to(thisImg, {
						css: { rotation: 0 }, duration: ((imgTransition / 4) * 3), ease: Quad.easeOut,
					}, (imgTransition / 2));
					tl.to(thisImg, {
						css: { scale: 1, translateX: 0 }, duration: imgTransition, ease: Quad.easeInOut,
					}, 0);
					tl.play();
				});
			}
		});
	}





// Init Selectric
// -----------------------------------------------------------------------------

	function initSelectric() {
		$("select").selectric({
			arrowButtonMarkup: "<b class='selectric-button'></b>",
			expandToItemText: false,
		});
	}


// Show more images
// -----------------------------------------------------------------------------

	function showImages() {
		$(document).on("click", ".js-show-images", (event) => {
			event.preventDefault();
			if ($(".js-gallery-block").hasClass("all-shown")) {
				$(".js-gallery-block").removeClass("all-shown");
			} else {
				$(".js-gallery-block").addClass("all-shown");
			}
			lazyLoadInstance.update();
		});
	}





// Triggers
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		ajaxSinglePage();
		closePanelOnClick();
		filterByCategory();
		filterBySearch();
		stickyToolbar();
		listItemHover();
		compensateSingleScrollbar();
		initLazyLoad();
		initFancybox();
		showImages();
		filterByYear();
		toggleMobileToolbarOnClick();
		initSelectric();
		resetFilters();
		searchOnClick();
		compensateOnSingleLoad();
		window.addEventListener("popstate", popStateListener);
	});




}(jQuery));
